// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IOzb","colBig":"styles_colBig__2niez","colSmall":"styles_colSmall__1dXuV","shopifyNameWrapper":"styles_shopifyNameWrapper__2XEcM"};